import request from '../utils'

const parameterApi = {
    parameterList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/parameter`)
        const res = await req;
        return res.body;
    }, 
    parameterDetail: async (modelingId, parameter) => {
        const req = request.get(`/api/modeling/${modelingId}/parameter/${parameter}`)
        const res = await req;
        return res.body;
    },
    parameterUpdate: async (modelingId, parameter) => {
        const req = request.put(`/api/modeling/${modelingId}/parameter/${parameter.id}`).send(parameter);
        const res = await req;
        return res.body;
    },
    parameterCreate: async (modelingId, parameter) => {
        const req = request.post(`/api/modeling/${modelingId}/parameter`).send(parameter);
        const res = await req;
        return res.body;
    },
    parameterDelete: async (modelingId, parameterId) => {
        const req = request.delete(`/api/modeling/${modelingId}/parameter/${parameterId}`);
        await req;
    },
    evaluationList: async (modelingId, parameterId) => {
        const req = request.get(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation`)
        const res = await req;
        return res.body;
    }, 
    evaluationDetail: async (modelingId, parameterId, evaluation) => {
        const req = request.get(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluation}`)
        const res = await req;
        return res.body;
    },
    evaluationUpdate: async (modelingId, parameterId, evaluation) => {
        const req = request.put(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluation.id}`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationCreate: async (modelingId, parameterId, evaluation) => {
        const req = request.post(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation`).send(evaluation);
        const res = await req;
        return res.body;
    },
    evaluationDelete: async (modelingId, parameterId, evaluationId) => {
        const req = request.delete(`/api/modeling/${modelingId}/parameter/${parameterId}/evaluation/${evaluationId}`);
        await req;
    }
};

export default parameterApi